import { cva } from 'class-variance-authority';

export const cvaPageWrapper = cva(['PageWrapperStyles-cvaPageWrapper'], {
  variants: {
    size: {
      own: ['mx-2.4 pb-2.4'],
      secondary: ['mx-1.4 pb-2.4'],
      third: ['mx-3.2'],
    },
    height: {
      full: ['min-h-svh'],
      fit: ['h-fit'],
    },
    noScroll: {
      true: ['overflow-hidden'],
    },
  },
});
